import React from "react";
import Section from "../components/Section";
import { Typography } from "payzli-ui";
import Link from "../components/Links/Link";

const LinkSection = () => {
	return (
		<Section title={"# Links"}>
			<div className="d-flex flex-wrap gap1 w-100">
				<Link label="Click Me - with hover" href="#" />
			</div>
			<div className="d-flex flex-wrap gap1 w-100">
				<Link label="Click Me - without hover" href="#" underline={false} />
			</div>
		</Section>
	);
};

export default LinkSection;
